/* eslint-disable */
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SubmenuButton from 'atoms/SubmenuButton/SubmenuButton';
import FolderTreeButton from 'layout/molecules/FolderTreeButton/FolderTreeButton';
import styles from './FoldersTreeMove.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectMoveFolder, selectFoldersTree, setCurrentFolder, setMoveFolder, } from 'store/specificationsMoveSlice';
import Checkbox from 'layout/atoms/Checkbox/Checkbox';
function FoldersTreeMove({ rootFolderId, folders = [], itemToMove, link }) {
    const dispatch = useDispatch();
    const { t } = useTranslation('specification');
    const wrapClasses = classNames(styles.wrap, styles.active);
    const [tree, setTree] = useState([]);
    const folderLink = link || '/specifications/folders';
    const moveFolder = useSelector(selectMoveFolder);
    const foldersTree = useSelector(selectFoldersTree);
    const buildTree = useCallback((rootFolderId, folders) => {
        const folderMap = new Map();
        const tree = [];
        folders.forEach((folder) => {
            folderMap.set(folder.id, Object.assign(Object.assign({}, folder), { children: [] }));
        });
        folders.forEach((folder) => {
            if (folder.parentId === rootFolderId) {
                tree.push(folderMap.get(folder.id));
            }
            else if (folderMap.has(folder.parentId)) {
                folderMap.get(folder.parentId).children.push(folderMap.get(folder.id));
            }
        });
        return tree;
    }, []);
    const isParentOf = useCallback((parentId, childId) => {
        if (!parentId || !childId || !foldersTree)
            return false;
        let currentFolder = foldersTree.find((f) => f.id === childId);
        while (currentFolder && currentFolder.parentId) {
            if (currentFolder.parentId === parentId)
                return true;
            currentFolder = foldersTree.find((f) => f.id === currentFolder.parentId);
        }
        return false;
    }, [foldersTree]);
    const isChildOf = useCallback((childId, parentId) => {
        return isParentOf(parentId, childId);
    }, [isParentOf]);
    const shouldDisableNode = useCallback((nodeId) => {
        if (!itemToMove)
            return false;
        return (nodeId === itemToMove || isParentOf(nodeId, itemToMove) || isChildOf(nodeId, itemToMove));
    }, [itemToMove, isParentOf, isChildOf]);
    useEffect(() => {
        if (folders.length > 0 || rootFolderId) {
            const treeData = buildTree(rootFolderId, folders);
            setTree((prevTree) => {
                if (JSON.stringify(prevTree) !== JSON.stringify(treeData)) {
                    return treeData;
                }
                return prevTree;
            });
        }
        else {
            setTree([]);
        }
    }, [folders, rootFolderId, buildTree]);
    function Tree({ nodes, isRoot }) {
        if (!nodes || nodes.length === 0)
            return null;
        return (React.createElement("ul", { className: classNames(styles.list, { [styles.child]: !isRoot }), "data-test": "move-folder" }, nodes.map((node, index) => (React.createElement(FolderTreeButton, { key: node.id, node: node, link: folderLink, onClick: () => dispatch(setCurrentFolder({ folderId: node.id })), disabled: shouldDisableNode(node.id), isLast: index === nodes.length - 1, isRoot: isRoot }, node.children && node.children.length > 0 && React.createElement(Tree, { nodes: node.children }))))));
    }
    return (React.createElement("nav", { className: wrapClasses },
        React.createElement("main", { className: styles.main },
            React.createElement("div", { className: styles.group },
                React.createElement("div", { className: styles.checkboxButton },
                    React.createElement(Checkbox, { onClick: () => dispatch(setMoveFolder({ folderId: rootFolderId })), value: moveFolder === rootFolderId, disabled: isParentOf(rootFolderId, itemToMove) }),
                    React.createElement(SubmenuButton, { text: React.createElement(React.Fragment, null, t('all_folders')), onClick: () => dispatch(setCurrentFolder({ folderId: rootFolderId })) }))),
            React.createElement(Tree, { nodes: tree, isRoot: true }))));
}
export default FoldersTreeMove;
